import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "../misc/Headings.js";
import Navbarlogedin from "./Navbarlogedin";
import { TextField, Button, Grid } from "@mui/material";
// import EmailIllustrationSrc from "../../images/email-illustration.svg";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./CompletedInterviews.css";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Issue = () => {
  const [state, setState] = React.useState({
    one: false,
    two: false,
    three: false,
    four: false,
    five: false,
  });

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const { one, two, three, four, five } = state;

  const subheading = "",
    heading = (
      <>
        <span tw="text-changed-100">Report an Issue</span>
        <wbr />
      </>
    ),
    description =
      "Please Enter the Mock Interview ID and then proceed to report your issue.",
    textOnLeft = true;
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  return (
    <>
      <Helmet>
        <title>Interwiu | Report an Issue</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              {subheading && <Subheading>{subheading}</Subheading>}
              <Heading>{heading}</Heading>
              {description && <Description>{description}</Description>}
            </TextContent>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <TextField
                  id="outlined-basic"
                  label="Enter the Mock Interview ID"
                  variant="outlined"
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <h5>Details of the Mock Interview </h5>
                <div className="interview-item-info">
                  <div className="interview-item">
                    <div className="interview-item-profile">
                      <img
                        src={require("../../images/photo.png")}
                        alt="Profile"
                      />
                      <button className="cust-btn view-btn">
                        View Profile
                      </button>
                    </div>
                    <div className="interview-item-info">
                      <div className="interviewer-head">
                        <h2>John Doe</h2>
                        <p>SDE, Google, California</p>
                      </div>
                      <div className="details flex">
                        <div className="detail">
                          <p className="detail-head">Profile</p>
                          <p className="detail-body">Data Science</p>
                        </div>
                        <div className="detail">
                          <p className="detail-head">Price</p>
                          <p className="detail-body">INR 900</p>
                        </div>
                        <div className="detail">
                          <p className="detail-head">Session Duration</p>
                          <p className="detail-body">30 Min</p>
                        </div>
                        <div className="detail">
                          <p className="detail-head">Interview Slot</p>
                          <p className="detail-body">[5:00PM - 5:45PM]</p>
                          <p className="detail-body">20 June, 2022</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <FormControl
                sx={{ m: 3 }}
                component="fieldset"
                variant="standard"
              >
                <FormLabel component="legend">
                  Please Check the issues you faced
                </FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={one}
                        onChange={handleChange}
                        name="one"
                      />
                    }
                    label="Student did not join for the mock interview at all"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={two}
                        onChange={handleChange}
                        name="two"
                      />
                    }
                    label="Student was unprofessional"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={three}
                        onChange={handleChange}
                        name="three"
                      />
                    }
                    label="Rather than joining alone, the student joined along with his/her friends"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={four}
                        onChange={handleChange}
                        name="four"
                      />
                    }
                    label="Student was trying to seek more of mentoring and guidance, rather than answering the interview-questions"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={five}
                        onChange={handleChange}
                        name="five"
                      />
                    }
                    label="Other Issues"
                  />
                  <TextField
                    id="outlined-multiline-static"
                    label="Describe your issue(s) in detail"
                    multiline
                    rows={4}
                    sx={{ mt: 2 }}
                  />
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item sx={{ mt: 2, mb: 2 }}>
              <Button variant="contained">Report the Issue</Button>
            </Grid>
          </TextColumn>
        </TwoColumn>
      </Container>
    </>
  );
};
export default Issue;
